import React from 'react'
import { Link } from 'react-router-dom'
import StoreAdd from './StoreAdd'

class StoreAddTab extends React.Component {
  state = {}
  componentDidMount() {
    if (
      this.props.match.params.Store_id !== undefined &&
      this.props.match.params.Store_id !== null &&
      this.props.match.params.Store_id !== 0 &&
      this.props.match.params.Store_id !== ''
    ) {
      this.setState({ Store_id: this.props.match.params.Store_id })
    }
  }
  handleLanguage = (language_id) => {
    this.setState({ language_id: language_id })
  }
  render() {
    return (
      <div className="main-body">
        <div className="page-wrapper">
          <div className="page-header">
            <div className="row align-items-end">
              <div className="col-lg-8">
                <div className="page-header-title">
                  <div className="d-inline">
                    <h4>{this.props.match.params.Store_id ? 'Edit' : 'Add'} Store</h4>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="page-header-breadcrumb">
                  <ul className="breadcrumb-title">
                    <li className="breadcrumb-item">
                      <Link to="/">
                        <i className="feather icon-home"></i>{' '}
                      </Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/store">Store</Link>
                    </li>
                    <li className="breadcrumb-item active">
                      {this.props.match.params.Store_id ? 'Edit' : 'Add'} Store
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="page-body">
            <div className="row">
              <div className="col-sm-12">
                <div className="card card-border-default">
                  <div className="card-block">
                    <div className="tab-content tabs">
                      <div
                        className="tab-pane  active"
                        id={'add_Store_' + this.state.language_id}
                        role="tabpanel"
                        aria-labelledby=""
                      >
                        {this.state.Store_id !== undefined &&
                        this.state.Store_id !== null &&
                        this.state.Store_id !== 0 &&
                        this.state.Store_id !== '' ? (
                          <StoreAdd
                            language_id={this.state.language_id}
                            goBack={this.props.history.goBack}
                            Store_id={this.state.Store_id}
                          />
                        ) : (
                          <StoreAdd
                            language_id={this.state.language_id}
                            goBack={this.props.history.goBack}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default StoreAddTab
